import { posix } from "path";
export const joinPath = posix.join;
